import kblClient from "./kblClient";
import client from "api/client";

export const getKblNotice = ({ searchValue, page, limit }) => {
  return kblClient.get(`/article/getKtNoticeList?searchValue=${searchValue}&page=${page}&limit=${limit}`);
};

export const getKblNoticeDetail = ({ seq }) => {
  return kblClient.get(`/article/getKtNoticeDetail?seq=${seq}`);
};

export const getKblSchedule = ({date}) => {
  return client.get(`/api/v2/kbl/schedule?date=${date}`)
}